import React from "react";
import { Box, Text } from "@chakra-ui/react";

const MessageBox = ({children}) => {
  return (
    <Box
      position="relative"
      display="inline-flex"
      alignItems="center"
      padding="6px 10px"
      fontSize="16px"
      color="white"
      borderRadius="6px"
      background="linear-gradient(to right, rgba(255, 255, 255, 0.2) 15%, rgba(255, 255, 255, 0) 100%)"
      _before={{
        content: '""',
        position: "absolute",
        inset: "0",
        borderRadius: "6px",
        padding: "1px",
        background: "linear-gradient(to right, rgba(255, 255, 255, 0.25) 25%, rgba(255, 255, 255, 0) 100%)",
        WebkitMask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        pointerEvents: "none",
      }}
      width={"fit-content"}
    >
      {children}
    </Box>
  );
};

export default MessageBox;